import api from '@/redux/api/video';
import cloneDeep from 'lodash/cloneDeep';
import { createSelector } from 'reselect';
import difference from 'lodash/difference';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';
import union from 'lodash/union';

/* Action Types */
const LOAD_STREAM_NAME_FAIL = 'la/domain/video/LOAD_FAIL';
const LOAD_STREAM_NAME_REQUEST = 'la/domain/video/LOAD_REQUEST';
const LOAD_STREAM_NAME_SUCCESS = 'la/domain/video/LOAD_SUCCESS';

// reducer
const DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: [],
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    let existing;
    let loaded;
    let loading;
    let time;

    switch (action.type) {
        case LOAD_STREAM_NAME_FAIL:
            return {
                ...state,
                loading: difference(state.loading, [action.meta.catalogId]),
            };
        case LOAD_STREAM_NAME_REQUEST:
            return {
                ...state,
                loading: union(state.loading, [action.payload]),
            };
        case LOAD_STREAM_NAME_SUCCESS:
            time = action.meta.actionTime;
            existing = cloneDeep(state.byId);
            loaded = { ...state.loaded, [action.meta.catalogId]: time };
            loading = cloneDeep(state.loading);
            existing[action.meta.catalogId] = action.payload;
            loading = difference(loading, [action.meta.catalogId]);
            return {
                ...state,
                byId: existing,
                loaded,
                loading,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.video;
const idSelector = (state: GlobalState, id) => id;

const byIdSelector = createSelector(stateSelector, (state) => state.byId);

const loadingSelector = createSelector(stateSelector, (state) => state.loading);

export const getStreamStatus: (state: any, selector: any) => any = createSelector(
    [byIdSelector, idSelector],
    (byId, id) => byId[id] || {}
);

const isStreamIdLoading = createSelector([loadingSelector, idSelector], (loading, id) => loading.includes(id));

/* ACTION CREATORS */
const loadStreamId = (catalogId) => async (dispatch, getState) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        dispatch({
            meta: { actionTime: Date.now() },
            payload: catalogId,
            type: LOAD_STREAM_NAME_REQUEST,
        });
        const { payload } = await api.fetchStreamId({
            authToken,
            catalogId,
            deployment,
        });

        dispatch({
            meta: { actionTime: Date.now(), catalogId },
            payload,
            type: LOAD_STREAM_NAME_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            meta: { catalogId },
            payload: error,
            type: LOAD_STREAM_NAME_FAIL,
        });
    }
};

export const fetchStreamIdIfNeeded = (catalogId: number) => async (dispatch: Function, getState: Function) => {
    if (!isStreamIdLoading(getState(), catalogId)) {
        return dispatch(loadStreamId(catalogId));
    }
    return Promise.resolve();
};
